/**
 * @module utils/router
 */

export function shouldHaveArrow () {
  let topOfStack = window.LocalstorageStack.top()
  if (!topOfStack) return false
  let pathname = topOfStack.pathname
  if (pathname === '/workscreen' || pathname === '/workscreen/' || pathname === '/orders' || pathname === '/orders/') return false
  return true
}



// WEBPACK FOOTER //
// ./src/app/utils/router.js